const carYearCheck = () => import('@/pages/carYearCheck/index')
const carYearCheckDetail = () => import('@/pages/carYearCheck/detail/index')
const yearCheckPage = () => import('@/pages/carYearCheck/pending/yearCheckPage')
const givePerson = () => import('@/pages/carYearCheck/pending/givePerson')
const leaveCheckPage = () => import('@/pages/carYearCheck/pending/leaveCheckPage')
const bothRecord = () => import('@/pages/carYearCheck/detail/record')
const errHandle = () => import('@/pages/carYearCheck/errhandle')
const createYearCheck = () => import('@/pages/carYearCheck/pending/createYearCheck')
export default [
  {
    path: '/carYearCheck',
    name: 'carYearCheck',
    component: carYearCheck,
    meta: {
      storeKey: 'mtc.renewal.drive'
    }
  },
  {
    path: '/createYearCheck',
    name: 'createYearCheck',
    component: createYearCheck,
    meta: {
    }
  },
  {
    path: '/carYearCheckDetail',
    name: 'carYearCheckDetail',
    component: carYearCheckDetail,
    meta: {
    }
  },
  {
    path: '/yearCheckPage',
    name: 'yearCheckPage',
    component: yearCheckPage,
    meta: {
    }
  },
  {
    path: '/givePerson',
    name: 'givePerson',
    component: givePerson,
    meta: {
    }
  },
  {
    path: '/leaveCheckPage',
    name: 'leaveCheckPage',
    component: leaveCheckPage,
    meta: {
    }
  },
  {
    path: '/bothRecord',
    name: 'bothRecord',
    component: bothRecord,
    meta: {
    }
  },
  {
    path: '/errhandle',
    name: 'errHandle',
    component: errHandle,
    meta: {
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/carYearCheck/index.js